export default __webpack_public_path__ + "static/media/ilus-badge-entry.d3c858c5.svg";